import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

const PricingSection = ({ bankForm, updateForm }) => {
  return (
    <div className="p-4 bg-amber-50 rounded-lg border border-amber-200 space-y-4">
      <h3 className="font-semibold text-sm text-amber-800">Pricing Information (Admin Only)</h3>
      <div className="grid grid-cols-3 gap-4">
        {(bankForm.pricingType === 'Rent' || bankForm.pricingType === 'Both') && (
          <>
            <div><Label>Effective Date</Label><Input data-testid="pricing-effective-date" type="date" value={bankForm.effectiveFrom || ''} onChange={(e) => updateForm('effectiveFrom', e.target.value)} /></div>
            <div><Label>Rent Amount</Label><Input data-testid="pricing-rent-amount" type="number" step="0.01" value={bankForm.rentAmount || ''} onChange={(e) => updateForm('rentAmount', e.target.value)} /></div>
            <div>
              <Label>Rent Cycle</Label>
              <Select value={bankForm.rentCycle} onValueChange={(val) => updateForm('rentCycle', val)}>
                <SelectTrigger data-testid="pricing-rent-cycle"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="Monthly">Monthly</SelectItem><SelectItem value="Weekly">Weekly</SelectItem><SelectItem value="Daily">Daily</SelectItem></SelectContent>
              </Select>
            </div>
          </>
        )}
        {(bankForm.pricingType === 'Commission' || bankForm.pricingType === 'Both') && (
          <>
            {bankForm.pricingType === 'Commission' && (
              <div><Label>Effective Date</Label><Input data-testid="pricing-commission-effective-date" type="date" value={bankForm.effectiveFrom || ''} onChange={(e) => updateForm('effectiveFrom', e.target.value)} /></div>
            )}
            <div><Label>Commission Rate/Amount</Label><Input data-testid="pricing-commission-rate" type="number" step="0.01" value={bankForm.commissionRate || ''} onChange={(e) => updateForm('commissionRate', e.target.value)} /></div>
          </>
        )}
        {bankForm.pricingType === 'Purchased' && (
          <>
            <div><Label>Purchase Amount</Label><Input data-testid="pricing-purchase-amount" type="number" step="0.01" value={bankForm.purchaseAmount || ''} onChange={(e) => updateForm('purchaseAmount', e.target.value)} /></div>
            <div><Label>Date of Purchase</Label><Input data-testid="pricing-purchase-date" type="date" value={bankForm.purchaseDate || ''} onChange={(e) => updateForm('purchaseDate', e.target.value)} /></div>
          </>
        )}
      </div>
    </div>
  );
};

export default PricingSection;
